import joi from 'joi';
import { email, password } from './common-schema';

// eslint-disable-next-line import/prefer-default-export
export const loginSchema = joi.object({
    email,
    password,
});
